(function(w,d) {
  var removeElements = [
    "input[class*=checkout-btn]",
    "input[class*=checkout-button]",
    "button[class*=checkout-btn]",
    "button[class*=checkout-button]",
    "[onclick*='/checkout']",
    "a[onclick*='/checkout']",
    "#ajaxifyCart [name=checkout]",
    "button[data-checkout=checkout]",
    "#AjaxifyCart [name=checkout]",
    "input[name=checkout]",
    "#slidecarthq footer button[class='button full']",
    "#topCheckoutButton",
    "div[class*='mm-panel'] input[type=submit]",
    "js-ajax-cart input[name=checkout]",
    "input[value='/checkout']",
    "form[class*=ajaxcart] button[name=checkouts]",
    "form[class*=ajaxcart] button[name=checkout]",
    "div[class='shopify-payment-button']",
    "button[class^='ajax-cart__button']",
    "button[value='Check Out']",
    "form[action='/checkout'] button[class^='check-out']",
    "div[class='menu_c cart_menu'] button[name=checkout]",
    "#shopify-section-static-cart > form > header > div.cart-title-right > button",
    "form[action='/checkout'] button[class*='add_to_cart']",
    "#dynamic-checkout-cart",
    "div[class='cart__additional_checkout']",
    "a[href='/checkout']",
    "input[onclick*='/checkout']",
    "button[onclick*='/checkout']",
    "div[data-shopify='payment-button']",
    "button[name=checkout]",
    "form[class^='js-cart_content__form'] input[value='Checkout']",
    "#additional-checkout-buttons",
    "div[class^='shopify-payment-button']"
  ];

  var redirectElements = [
    "a[href='/checkout']",
    "input[class*=checkout-btn]",
    "input[class*=checkout-button]",
    "button[class*=checkout-btn]",
    "button[class*=checkout-button]",
    "div[class*='mm-panel'] input[type=submit]",
    "#slidecarthq footer button[class='button full']",
    "form[class*=ajaxcart] button[name=checkouts]",
    "form[class*=ajaxcart] button[name=checkout]",
    "button[class^='ajax-cart__button']",
    "form[class^='js-cart_content__form'] input[value='Checkout']",
    "button[value='Check Out']",
    "div[class='menu_c cart_menu'] button[name=checkout]",
    "form[action='/checkout'] button[class*='add_to_cart']"
  ];

  var hideCart = [
    "#dynamic-checkout-cart",
    "div[class='cart__additional_checkout']",
    "div[data-shopify='payment-button']",
    "#additional-checkout-buttons",
    "div[class^='shopify-payment-button']"
  ];

  setInterval(function() {
    for(var i = 0; i < removeElements.length; i++) {
      var allElements = document.querySelectorAll(removeElements[i]);

      for(var x = 0; x < allElements.length; x++) {
        var element = allElements[x];

        if(element.name && element.name.toLowerCase() == "return_to") {
          element.value = "/cart";
        }
        else if(
          redirectElements.indexOf(removeElements[i]) != -1 &&
          (window.location.pathname + window.location.search).indexOf("/cart") == -1 &&
          (!element.getAttribute("name") ||
            (element.getAttribute("name") &&
             element.getAttribute("name").indexOf("ac-checkout") == -1))
        ) {
          let parent = element.parentElement;
          let btn = document.createElement("button");

          btn.className = element.className + " ac-checkout";
          btn.setAttribute("type", "button");
          btn.setAttribute("name", "ac-checkout");

          if(element.getAttribute("style")) {
            btn.setAttribute("style", element.getAttribute("style"));
          }

          btn.setAttribute("onclick", "window.location.href = '/cart'");
          btn.textContent = "Checkout";

          parent.appendChild(btn);
          parent.removeChild(element);
        }
        else if(
          element.name &&
          element.name.toLowerCase() == "checkout" &&
          (window.location.pathname + window.location.search).indexOf("/cart") == -1 &&
          (!element.getAttribute("name") ||
            (element.getAttribute("name") &&
             element.getAttribute("name").indexOf("ac-checkout") == -1))
        ) {
          if((window.location.pathname + window.location.search).indexOf("/cart") == -1) {
            element.setAttribute("type", "button");
            element.setAttribute("name", "ac-checkout");
            element.setAttribute("onclick", "window.location.href = '/cart'");
          }
        }
        else if(
          element.getAttribute("onclick") &&
          element.getAttribute("onclick").indexOf("'/checkout'") != -1 &&
          (!element.getAttribute("name") ||
            (element.getAttribute("name") &&
             element.getAttribute("name").indexOf("ac-checkout") == -1))
        ) {
          element.setAttribute("name", "ac-checkout");
          element.setAttribute("onclick", "window.location.href = '/cart'");
        }
        else if(
          !element.getAttribute("name") ||
          (element.getAttribute("name") &&
           element.getAttribute("name").indexOf("ac-checkout") == -1)
        ) {
          if((window.location.pathname + window.location.search).indexOf("/cart") != -1) {
            if(hideCart.indexOf(removeElements[i]) != -1) {
              element.style.display = "none";
            }
          } else {
            element.style.display = "none";
          }
        }
      }
    }
  }, 50);

})(window, document);